// @ts-nocheck
import axios from 'axios'
import { apiUrl } from '../config'
import authenticationStore from '../stores/authenticationStore'

const getAuthHeaders = () => ({
  Authorization: `Bearer ${
    JSON.parse(authenticationStore.appToken).access_token
  }`,
  'Content-Type': 'application/json',
})

const endPoint = `${apiUrl}/api/v1/internal-ratings`

export const InternalRatingRequest = {
  createRating: rating =>
    axios.post(endPoint, rating, { headers: getAuthHeaders() }),
  updateEvaluationDetail: (code, evaluatorType, detail) =>
    axios.put(`${endPoint}/${code}/${evaluatorType}/details`, detail, {
      headers: getAuthHeaders(),
    }),
  getRatingWithDetails: code =>
    axios.get(`${endPoint}/${code}`, { headers: getAuthHeaders() }),
  getEvaluationDetails: code =>
    axios.get(`${endPoint}/${code}/details`, { headers: getAuthHeaders() }),
  getAllRatings: params =>
    axios.get(endPoint, { headers: getAuthHeaders(), params }),
  updateStatus: (code, data) =>
    axios.patch(`${endPoint}/${code}/status`, data, {
      headers: getAuthHeaders(),
    }),
  updateRating: (code, rating) =>
    axios.put(`${endPoint}/${code}`, rating, { headers: getAuthHeaders() }),
  updateAssignUser: (code, assignUserUpdateRequest) =>
    axios.put(`${endPoint}/${code}/assign-users`, assignUserUpdateRequest, {
      headers: getAuthHeaders(),
    }),
  deleteRating: code =>
    axios.delete(`${endPoint}/${code}`, { headers: getAuthHeaders() }),
}
